import React, { Fragment } from 'react';
import {useAppState, getBackgroundImg, getUploadedImagePath, MarkupRender} from '@nutastic/nutastic-react-app';

const HomePage = () => {
    const {
        page: {
            content: bannerText,
            field_1: bannerTitle,
            field_2: bannerButton1Text,
            field_3: bannerButton1Url,
            field_4: bannerButton2Text,
            field_5: bannerButton2Url,
            field_6: introText,
            field_7: aboutTitle,
            field_8: aboutText,
            field_9: aboutButtonText,
            field_10: aboutButtonUrl,
            image_1: bannerBackgroundImage,
            image_2: bannerImage,
            image_3: aboutImage,
            num_1: showBannerImage
        }
    } = useAppState();
    const componentClass = 'home-page';

    return <Fragment>
        <div className={`${componentClass}__banner`} style={getBackgroundImg(getUploadedImagePath(bannerBackgroundImage))}>
            <div className="overlay" />
            <h1 className={`${componentClass}__mobileHeader`}>{ bannerTitle }</h1>
            <div className="container h-100">
                <div className={`${componentClass}__banner-content`}>
                    <div className="script-text">especially for you!</div>
                    <h1>{ bannerTitle }</h1>
                    <p>{ bannerText }</p>
                    <div className="buttons">
                        { bannerButton2Text && <a href={bannerButton1Url} className="btn btn-secondary">{ bannerButton1Text }</a> }
                        { bannerButton2Text && <a href={bannerButton2Url} className="btn btn-outline-secondary">{ bannerButton2Text }</a> }
                    </div>
                </div>
                { showBannerImage && <img className={`${componentClass}__banner-image`} src={getUploadedImagePath(bannerImage)} alt={bannerTitle} /> }
            </div>
        </div>
        <div className={`${componentClass}__highlights page-section page-section--padded`}>
            <div className="overlay" />
            <div className="container">
                <MarkupRender className="paragraph" content={introText} />
            </div>
        </div>
        <section className={`${componentClass}__details page-section page-section--padded`}>
            <div className="container">
                <img src={getUploadedImagePath(aboutImage)} alt={aboutTitle} />
                <div className="details-break-line" />
                <div className="paragraph">
                    <h2 className="mb-5">{ aboutTitle }</h2>
                    <MarkupRender className="mt-3 mb-3" content={aboutText} />
                    { aboutButtonText && <a href={aboutButtonUrl} className="btn btn-primary btn-small mt-5">{ aboutButtonText }</a> }
                </div>
            </div>
        </section>
    </Fragment>;
};

export default HomePage;
